<template>
  <div :class="variantCls.root">
    <div
      v-for="(option, i) in options"
      :key="i"
      :class="[
        compare(option, value) ? variantCls.itemSelected : variantCls.item
      ]"
      :tabindex="disabled ? '-1' : '0'"
      @click="onClick(option)"
      @keyup.enter="onClick(option)"
      @focus="emit('focus')"
      @blur="emit('blur')"
    >
      {{ option[nameKey] }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: "default"
    },
    value: {
      required: true,
      default: "",
      validator(val) {
        return val === null || typeof val === "string"
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      required: true,
      default: () => [],
      type: Array
    },
    nameKey: {
      type: String,
      default: "name"
    },
    valueKey: {
      type: String,
      default: "value"
    }
  },

  computed: {
    variantCls() {
      return this.$store.getters.variants("JRadios", this.variant).el
    }
  },

  methods: {
    onClick(option) {
      if(this.disabled) return
      this.$emit("input", option[this.valueKey])
		},
    
    emit(...args) {
      if (!this.disabled) {
        this.$emit(...args)
      }
    },

    compare(option, valueTwo) {
      if (option[this.valueKey] === valueTwo) return true
      else return false
    }
  }
}
</script>
